<nav class="layout-breadcrumb">
    <ol>
        <ng-template ngFor let-item let-first="first" let-last="last" [ngForOf]="breadcrumbs$ | async">
            <li 
                [routerLink]="!first ? item.url : null" 
                [ngClass]="{
                    'breadcrumb-item': true,
                    'breadcrumb-clickable': !first && !last,
                    'breadcrumb-disabled': first || last
                }"
            >
                {{ item.label }}
            </li>
            <li *ngIf="!last" class="layout-breadcrumb-chevron"> / </li>
        </ng-template>
    </ol>
</nav>
